export default __webpack_public_path__ + "media/design-system/form/assets/checkmark-0be14ab88836dc6573b6c8e352c09f5d.svg";